module.exports = __webpack_public_path__ + "static/media/24.f5e04da0.wav";